var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures2Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.3478 7.09961C33.6821 7.09961 35.0033 7.36241 36.236 7.87301C37.4687 8.38361 38.5887 9.13201 39.5322 10.0755C40.4757 11.0189 41.2241 12.139 41.7347 13.3717C42.2453 14.6044 42.5081 15.9256 42.5081 17.2599C42.5081 21.5972 36.439 29.8496 33.6822 33.3763C33.5238 33.579 33.3213 33.743 33.0901 33.8557C32.8589 33.9685 32.605 34.0271 32.3478 34.0271C32.0906 34.0271 31.8367 33.9685 31.6055 33.8557C31.3743 33.743 31.1718 33.579 31.0134 33.3763C28.2566 29.8518 22.1875 21.5972 22.1875 17.2599C22.1875 14.5652 23.258 11.9809 25.1634 10.0755C27.0688 8.17006 29.6531 7.09961 32.3478 7.09961Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8115 27.4908C18.2414 27.61 17.7116 27.8741 17.2734 28.2578C16.8352 28.6414 16.5033 29.1316 16.3098 29.6809L8.54055 53.3882C8.36041 53.8989 8.30535 54.4453 8.37997 54.9816C8.4546 55.518 8.65675 56.0286 8.96946 56.4707C9.28217 56.9128 9.69633 57.2734 10.1772 57.5224C10.6581 57.7714 11.1916 57.9014 11.7331 57.9016H52.9614C53.5032 57.9016 54.037 57.7715 54.5181 57.5224C54.9992 57.2733 55.4135 56.9124 55.7263 56.47C56.0391 56.0276 56.2411 55.5167 56.3156 54.9801C56.39 54.4434 56.3346 53.8967 56.154 53.386L48.3847 29.6787C48.1898 29.1264 47.855 28.6341 47.4129 28.2498C46.9709 27.8655 46.4368 27.6025 45.8627 27.4863",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 57.8983L25.5743 37.5801",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5079 57.8983L39.1211 37.5801",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.457 47.7402H54.3066",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 37.5801H25.5724",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1211 37.5801H50.9748",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 32.5,
    cy: 17,
    r: 2.5,
    fill: "#6263AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures2Svg);
export default __webpack_public_path__ + "static/media/features2SVG.69fbe13f8ef2528d5ed9f5266a2560a2.svg";
export { ForwardRef as ReactComponent };